import { debug, observer, pr, React, RouteComponentProps, ui } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { ZERO_AMOUNT } from "types/amount";
import { hasError } from "types/error";
import { FEETYPE_REISSUE_CARD } from "types/fee";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../signing/views/SigningComponent";
import { FormattedAmount } from "../util/FormattedAmount";
import { ReissueCardStore } from "./ReissueCardStore";

type IProps = RouteComponentProps<{}> & {
    store: ReissueCardStore;
};

@observer
export class ReissueCardSigning extends React.Component<IProps, {}> {
    render() {
        const cardName = this.props.store.cardStore && this.props.store.cardStore.card ? this.props.store.cardStore.card.productI18N : "-";
        const fee = this.props.store.feesStore.getFeeForType(FEETYPE_REISSUE_CARD);
        const amount = fee ? fee.fee : ZERO_AMOUNT;

        return (
            <SigningComponent
                signingInfo={this.props.store.response ? this.props.store.response.signInfo : undefined}
                content={
                    <div>
                        <pr.SigningLabelContainer>
                            <pr.SigningLabelSet>
                                <pr.SigningLabelTitle>{ui.__("loan.signing.product.title")}</pr.SigningLabelTitle>
                                <pr.SigningLabel>{cardName}</pr.SigningLabel>
                            </pr.SigningLabelSet>
                            <br />
                            <pr.SigningLabelSet>
                                <pr.SigningLabelTitle>{ui.__("common.fees")}</pr.SigningLabelTitle>
                                <FormattedAmount amount={amount} big />
                            </pr.SigningLabelSet>
                        </pr.SigningLabelContainer>
                    </div>
                }

                onSuccess={(response: ISigningResponse) => {
                    debug.log("### signing success", response);
                    pushRoute("success");
                }}
                onError={(error: any) => {
                    if (hasError(error, {
                        scope: "signingObject.card",
                        error: "NOT_POSSIBLE"
                    })) {
                        pushRoute("/error");
                    }
                }}

                onRetry={async () => await this.props.store.reissueCard()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/reissueCard/ReissueCardSigning.tsx